import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { SamplePrevArrow, SampleNextArrow } from './slider-slick';
import API_URL from '../../services';

function CategoryBox({ id, name, imageURL }) {
  return (
    <Link
      to={`market-place/${name}-${id}`}
      className="border flex flex-col
                    hover:shadow-b-md z-0
                    xs:h-40"
      key={`${id}${name}`}
    >
      <div className="flex flex-col hover:border-2 xs:h-40">
        <div className="relative xs:h-40 flex justify-center">
          <img
            src={imageURL ? `${API_URL}${imageURL}` : null}
            alt="..."
            className="object-scale-down  xs:max-h-36"
            loading="lazy"
          />
          <div className="p-1 flex w-full justify-center absolute bottom-5">
            <h3 className="text-main font-bold font-serif capitalize">
              {name}
            </h3>
          </div>
        </div>
      </div>
    </Link>
  );
}
CategoryBox.defaultProps = {
  imageURL: null,
};

CategoryBox.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  imageURL: PropTypes.string,
};

const Settings = {
  className: 'grid grid-cols-6 grid-rows-2 xs:auto-rows-max mb-2 p-5 xs:hidden bg-white relative',
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 6,
  rows: 2,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export { CategoryBox, Settings };
